import React from 'react';
import './AlertModal.scss';

const AlertModal = ({
                   isOpen,
                   onClose,
                   icon,
                   title,
                   description,
                   children,
                   buttons,
                   className = '',
                   showCloseButton = true,
                   overlayClosable = true,
               }) => {
    if (!isOpen) return null;

    const handleOverlayClick = (e) => {
        if (overlayClosable && e.target === e.currentTarget) {
            onClose?.();
        }
    };

    return (
        <div className="modal" onClick={handleOverlayClick}>
            <div className={`modal__container ${className}`}>
                {showCloseButton && (
                    <button
                        className="modal__close"
                        onClick={onClose}
                        aria-label="Close modal"
                    >
                        ×
                    </button>
                )}

                {icon && (
                    <div className="modal__icon">
                        {typeof icon === 'string' ? (
                            <img src={icon} alt="" className="modal__icon-img" />
                        ) : (
                            icon
                        )}
                    </div>
                )}

                {title && <h2 className="modal__title">{title}</h2>}

                {description && (
                    <div className="modal__description">{description}</div>
                )}

                {children && <div className="modal__content">{children}</div>}

                {buttons && buttons.length > 0 && (
                    <div className="modal__actions">
                        {buttons.map((button, index) => (
                            <button
                                key={index}
                                className={`modal__button modal__button--${button.variant || 'primary'} ${
                                    button.className || ''
                                }`}
                                onClick={button.onClick}
                                disabled={button.disabled}
                                type={button.type || 'button'}
                            >
                                {button.icon && (
                                    <span className="modal__button-icon">{button.icon}</span>
                                )}
                                <span className="modal__button-text">{button.label}</span>
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default AlertModal;
